export const ACCESS_MODULES = [
    { key: "dashboard", label: "Painéis", description: "Dashboards executivo e operacional e resumo.", routes: ["/", "/operacional", "/resumo"] },
    { key: "vendas", label: "Vendas", description: "Pedidos, televendas, canais, margens, pipeline, orçamentos e cupons.", routes: ["/pedidos", "/televendas", "/canais", "/margens", "/crm/pipeline", "/crm/orcamentos", "/cupons"] },
    { key: "catalogo", label: "Catálogo e estoque", description: "Produtos, categorias, aplicações, estoque e divergências.", routes: ["/catalogo", "/categorias", "/aplicacoes", "/estoque", "/disponibilidade", "/divergencias"] },
    { key: "relacionamento", label: "Atendimento e clientes", description: "WhatsApp, clientes, notificações, tarefas, segmentos e fluxos.", routes: ["/inbox", "/clientes", "/notificacoes", "/crm/respostas-rapidas", "/crm/grupos", "/crm/fluxos", "/crm/tarefas", "/crm/segmentos"] },
    { key: "logistica", label: "Logística", description: "Expedição, rastreio, sincronização e garantias.", routes: ["/expedicao", "/rastreio", "/sincronizacao", "/garantias"] },
    { key: "financeiro", label: "Financeiro", description: "Contas a pagar e a receber, fluxo de caixa, conciliação e rentabilidade.", routes: ["/financeiro"] },
    { key: "marketing", label: "Marketing da loja", description: "Faixa de pré-venda e banners da loja.", routes: ["/marketing"] },
    { key: "sistema", label: "Sistema", description: "Integrações, auditoria e configurações.", routes: ["/integracoes", "/auditoria", "/configuracoes"] }
];
export const ACCESS_LEVELS = [
    { level: "none", label: "Sem acesso", hint: "Não vê o módulo no menu e o servidor recusa as chamadas." },
    { level: "view", label: "Só visualizar", hint: "Vê os dados, mas não cria, edita nem exclui." },
    { level: "edit", label: "Visualizar e editar", hint: "Acesso completo ao módulo." }
];
function allModules(level) {
    return Object.fromEntries(ACCESS_MODULES.map((module) => [module.key, level]));
}
export const ACCESS_PRESETS = [
    { id: "completo", label: "Operador completo", description: "Edita todos os módulos.", permissions: allModules("edit") },
    { id: "vendas", label: "Vendas", description: "Pedidos e clientes; só vê catálogo e financeiro.", permissions: { ...allModules("none"), dashboard: "view", vendas: "edit", catalogo: "view", relacionamento: "edit", logistica: "view", financeiro: "view" } },
    { id: "atendimento", label: "Atendimento", description: "WhatsApp e clientes; só vê pedidos e catálogo.", permissions: { ...allModules("none"), dashboard: "view", vendas: "view", catalogo: "view", relacionamento: "edit", logistica: "view" } },
    { id: "financeiro", label: "Financeiro", description: "Edita o financeiro; só vê vendas.", permissions: { ...allModules("none"), dashboard: "view", vendas: "view", financeiro: "edit" } },
    { id: "logistica", label: "Expedição", description: "Expedição, rastreio e garantias; só vê pedidos.", permissions: { ...allModules("none"), dashboard: "view", vendas: "view", catalogo: "view", logistica: "edit" } },
    { id: "leitura", label: "Somente leitura", description: "Vê todos os módulos, não altera nada.", permissions: allModules("view") }
];
const LEVELS = ["none", "view", "edit"];
const MODULE_KEYS = ACCESS_MODULES.map((module) => module.key);
/** Valida o mapa recebido do cliente: só módulos e níveis conhecidos. */
export function parsePermissions(input) {
    if (input === undefined || input === null)
        return { ok: true, value: {} };
    if (typeof input !== "object" || Array.isArray(input))
        return { ok: false, error: "permissions_must_be_an_object" };
    const value = {};
    for (const [key, level] of Object.entries(input)) {
        if (!MODULE_KEYS.includes(key))
            return { ok: false, error: `unknown_module:${key}` };
        if (typeof level !== "string" || !LEVELS.includes(level))
            return { ok: false, error: `invalid_level:${key}` };
        value[key] = level;
    }
    return { ok: true, value };
}
/** Nível efetivo de um módulo para o papel e o mapa informados. */
export function levelFor(role, permissions, module) {
    if (role === "admin")
        return "edit";
    return permissions?.[module] ?? "edit";
}
/** Mapa completo (todos os módulos resolvidos) — o que a tela e o menu consomem. */
export function resolveAccess(role, permissions) {
    return Object.fromEntries(ACCESS_MODULES.map((module) => [module.key, levelFor(role, permissions, module.key)]));
}
export function moduleForPath(pathname) {
    const path = pathname.length > 1 ? pathname.replace(/\/$/, "") : pathname;
    if (path === "/")
        return "dashboard";
    let best = null;
    for (const module of ACCESS_MODULES) {
        for (const route of module.routes) {
            if (route === "/")
                continue;
            if ((path === route || path.startsWith(`${route}/`)) && (!best || route.length > best.length))
                best = { key: module.key, length: route.length };
        }
    }
    return best?.key ?? null;
}
/** Nível necessário para um método HTTP: leitura precisa de `view`, o resto de `edit`. */
export function requiredLevel(method) {
    return method === "GET" || method === "HEAD" || method === "OPTIONS" ? "view" : "edit";
}
export function levelAllows(have, need) {
    const rank = { none: 0, view: 1, edit: 2 };
    return rank[have] >= rank[need];
}
export function validateEmail(value) {
    if (typeof value !== "string")
        return null;
    const email = value.trim().toLowerCase();
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email) && email.length <= 254 ? email : null;
}
/** Senha da equipe: 8+ caracteres, com letra e número. Devolve o motivo ou `null` se válida. */
export function passwordProblem(value) {
    if (typeof value !== "string" || value.length < 8)
        return "A senha precisa ter pelo menos 8 caracteres.";
    if (value.length > 72)
        return "A senha pode ter no máximo 72 caracteres.";
    if (!/[A-Za-z]/.test(value) || !/\d/.test(value))
        return "A senha precisa ter letras e números.";
    return null;
}
/**
 * Travas de segurança do CRUD de usuários — as mesmas na Edge Function e no servidor de dev:
 * ninguém exclui, bloqueia ou rebaixa a si mesmo (perderia o acesso no meio da tela), e o último
 * administrador ativo não sai do sistema (ninguém mais conseguiria gerenciar usuários).
 */
export function guardUserChange(input) {
    if (input.change === "other")
        return null;
    if (input.actorId === input.targetId)
        return "cannot_modify_self";
    const removesAdmin = input.targetRole === "admin" && input.targetStatus === "active";
    if (removesAdmin && input.activeAdminCount <= 1)
        return "last_admin";
    return null;
}
